/** Styles of ScreenManagerView (Laitteet, /screen-manager). */
import styled from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  background: #000;
`;

/* Old Header - replaced by AdminHeader
*/

/* ConnectionBadge and StatusDot - now handled by AdminHeader
*/

export const SelectorContainer = styled.div`
  min-height: 100vh;
  background: #0a0a0a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
`;

export const SelectorTitle = styled.h1`
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 8px;
`;

export const SelectorSubtitle = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 40px;
`;

export const InstanceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 400px;
`;

export const InstanceButton = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px 24px;
  background: linear-gradient(145deg, #1a1a1a, #222);
  border: 1px solid #333;
  border-radius: 12px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;

  &:hover {
    border-color: #0099ff;
    background: linear-gradient(145deg, #1e1e1e, #262626);
  }
`;

export const InstanceIcon = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #0099ff, #9933ff);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
`;

export const InstanceInfo = styled.div`
  flex: 1;
`;

export const InstanceTitle = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const InstanceId = styled.div`
  font-size: 12px;
  color: #666;
  font-family: 'JetBrains Mono', monospace;
`;
